// app/frontend/src/components/callbutton.tsx
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface CallButtonProps {
    phoneNumber: string;
}

const CallButton = ({ phoneNumber }: CallButtonProps) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const { t } = useTranslation();

    const handleCall = async () => {
        setLoading(true);
        setMessage("");

        // Use the phoneNumber prop instead of hardcoded value
        console.log("Initiating call to:", phoneNumber);
        const apiUrl = `./outboundCall?to=${encodeURIComponent(phoneNumber)}`;
        try {
            const response = await fetch(apiUrl, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });
            const data = await response.json();
            if (response.ok) {
                setMessage(`Call initiated: ${data.call_id}`);
            } else {
                setMessage(`Error: ${data.error}`);
            }
        } catch (error) {
            setMessage(`Failed to connect: ${(error as Error).message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <button
                onClick={handleCall}
                disabled={loading}
                className="w-full rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                {loading ? "Calling..." : t("un_demo.mobile.startOutboundCall")}
            </button>
            {message && <p className="mt-2 text-sm text-gray-600">{message}</p>}
        </div>
    );
};

export default CallButton;
